import Index from '@/views/index.vue'
export default [
  {
    path: '/',
    name: 'home',
    component: Index,
    redirect: '/member',
    children: [
      {
        path: '/member',
        meta: {
          title: '用户中心'
        },
        name: 'member',
        component: () => import('@/views/member.vue')
      },
      {
        path: '/store',
        name: 'store',
        component: () => import('@/views/statements/store.vue')
      },
      {
        path: '/clerk',
        name: 'clerk',
        component: () => import('@/views/statements/clerk.vue')
      },
      {
        path: '/transaction',
        name: 'transaction',
        component: () => import('@/views/statements/transaction.vue')
      },
      {
        path: '/mc-received',
        name: 'mc-received',
        component: () => import('@/views/statements/mc/received.vue')
      },
      {
        path: '/mc-refund',
        name: 'mc-refund',
        component: () => import('@/views/statements/mc/refund.vue')
      },
      {
        path: '/net-charge',
        name: 'net-charge',
        component: () => import('@/views/statements/mc/net-charge.vue')
      },
      {
        path: '/order',
        name: 'order',
        meta: {
          title: '订单明细'
        },
        component: () => import('@/views/order/index.vue')
      },
      {
        path: '/refund',
        name: 'refund',
        meta: {
          title: '订单明细'
        },
        component: () => import('@/views/order/refund.vue')
      },
      {
        path: '/login',
        name: 'login',
        meta: {
          title: '登录'
        },
        component: () => import('@/views/login/index.vue')
      },
      {
        path: '/auth',
        name: 'auth',
        meta: {
          title: '微信授权'
        },
        component: () => import('@/views/auth.vue')
      }
    ]
  }
]
